import React, { useState, useEffect, useCallback } from 'react';
import { Card, Radio, Spin, Typography } from 'antd';
import { Box } from '@mui/material';
import { httpGet, httpPut, customBaseUrl } from '../../../store/http';
import { showLoader, hideLoader } from '../../../utils/loader';
import { NotificationManager } from 'react-notifications';
import themeColor from '../../../theme/color';

const BillsProvider = () => {
  const [billsRoute, setBillsRoute] = useState("");
  const [fetchingBillsRoute, setFetchingBillsRoute] = useState(false);
  const [togglingBillsRoute, setTogglingBillsRoute] = useState(false);

  const fetchBillsRoute = useCallback(async () => {
    setFetchingBillsRoute(true);
    try {
      const res = await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/bills/routing`);
      if (res?.success || res?.status) {
        setBillsRoute(res.data?.provider || res.data);
      }
    } catch (error) {
      console.error("Error fetching bills route:", error);
    } finally {
      setFetchingBillsRoute(false);
    }
  }, []);

  const toggleBillsRoute = async (newRoute) => {
    setTogglingBillsRoute(true);
    showLoader();
    try {
      const res = await httpPut(`${customBaseUrl.tranv2}/api/v1/admin/bills/routing`, { provider: newRoute });
      if (res?.success || res?.status) {
        setBillsRoute(newRoute);
        NotificationManager.success(`Bills Payment route switched to ${newRoute}`);
      } else {
        NotificationManager.error(res?.message || "Failed to switch Bills Payment route.");
      }
    } catch (error) {
      NotificationManager.error("An error occurred while switching the Bills Payment route.");
      console.error("Error toggling bills route:", error);
    } finally {
      setTogglingBillsRoute(false);
      hideLoader();
    }
  };

  useEffect(() => {
    fetchBillsRoute();
  }, [fetchBillsRoute]);

  return (
    <Spin spinning={fetchingBillsRoute || togglingBillsRoute} tip="Loading/Switching Route...">
      <Card title="Bills Payment Provider Routing" bordered={false} className="shadow-sm">
        <Box sx={{ mb: 4 }}>
          <Typography.Title level={5} style={{ fontWeight: 700 }}>
            Select Active Provider
          </Typography.Title>
          <Typography.Paragraph type="secondary" style={{ marginBottom: 24 }}>
            Switching the provider will immediately route all bill payments through the selected platform.
          </Typography.Paragraph>

          <Radio.Group
            value={billsRoute}
            onChange={(e) => toggleBillsRoute(e.target.value)}
            disabled={togglingBillsRoute}
            size="large"
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Card
                hoverable
                onClick={() => !togglingBillsRoute && toggleBillsRoute('BAXI')}
                style={{
                  border: billsRoute === 'BAXI' ? `2px solid ${themeColor.primary}` : '1px solid #f0f0f0',
                  borderRadius: 8,
                  width: '100%',
                  maxWidth: 400
                }}
              >
                <Radio value="BAXI">
                  <Box sx={{ ml: 1 }}>
                    <Typography.Text strong>BAXI</Typography.Text>
                    <br />
                    <Typography.Text type="secondary" style={{ fontSize: '12px' }}>Route bills via Baxi</Typography.Text>
                  </Box>
                </Radio>
              </Card>

              <Card
                hoverable
                onClick={() => !togglingBillsRoute && toggleBillsRoute('QUICKTELLER')}
                style={{
                  border: billsRoute === 'QUICKTELLER' ? `2px solid ${themeColor.primary}` : '1px solid #f0f0f0',
                  borderRadius: 8,
                  width: '100%',
                  maxWidth: 400
                }}
              >
                <Radio value="QUICKTELLER">
                  <Box sx={{ ml: 1 }}>
                    <Typography.Text strong>QUICKTELLER</Typography.Text>
                    <br />
                    <Typography.Text type="secondary" style={{ fontSize: '12px' }}>Route bills via Quickteller</Typography.Text>
                  </Box>
                </Radio>
              </Card>
            </Box>
          </Radio.Group>
        </Box>
      </Card>
    </Spin>
  );
};

export default BillsProvider;
